/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

// take format names from https://www.ibm.com/docs/ru/spss-statistics/24.0.0?topic=formats-date-time column format types

export enum DurationFormatTypes {
    FullWord = 'FullWord', // 5 hours 15 minutes 45 seconds
    ShortFullWord = 'ShortFullWord', // 5 minutes 45 seconds
    TIMEw4 = 'hh:mm', // hh:mm
    TIMEw8 = 'hh:mm:ss', // hh:mm:ss
    MTIMEw = 'mm:ss', // mm:ss
}
